import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DataStateChangeEventArgs, GridComponent, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalComponent } from 'src/app/global/global.component';
import { GetMenusBO, saveFunctionBo, sideMenuItemsIdBo } from '../menus-new.modal';
import { MenusService } from '../menus-new.service';
import { FunctionDateService } from './function-code.service';
@Component({
  selector: 'app-function-code',
  templateUrl: './function-code.component.html',
  styleUrls: ['./function-code.component.scss']
})
export class FunctionComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  @ViewChild('gridFunction') public gridFunction: GridComponent;
  isSaveorUpdateBoolean:boolean=false;
  @Input() InputProperty: sideMenuItemsIdBo;
  public filterSettings: object;
  MenuList: any = [];
  saveFunctionInfo:saveFunctionBo=new saveFunctionBo();
 
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  initialPage: PageSettingsModel;
  MenusFilterBo: GetMenusBO = new GetMenusBO();
  public GridList: Observable<DataStateChangeEventArgs>;
  constructor(public DateService: FunctionDateService,
    public MService: MenusService,
    public global: GlobalComponent,
    public toasterservice: ToastrService) {
    this.GridList = DateService;
  }
  ngOnInit(): void {
    
    this.filterSettings = {
      type: 'Menu',
    };
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
    this.MenusFilterBo.field = "functionCode";
    this.MenusFilterBo.orderColumn = "functionCode";
    this.getFunctionFilter();
  }
  //.........................................dataChangeFunction.....................................................
  public dataChangeFunction(F): void {
    let val = (F.action.requestType).toString();
    if (val != "filterchoicerequest") {
      if ((F.sorted || []).length) {
        this.MenusFilterBo.orderColumn = F.sorted[0].name;
        this.MenusFilterBo.orderType = F.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (val == "filtering" && F.action.action != "clearFilter") {
      this.MenusFilterBo.value = F.action.currentFilterObject.value;
      this.MenusFilterBo.field = F.action.currentFilterObject.field;
      this.MenusFilterBo.matchCase = F.action.currentFilterObject.matchCase;
      this.MenusFilterBo.operator = F.action.currentFilterObject.operator;
    }
    else {
      if (val == "filtering" && F.action.action == "clearFilter") {
        this.MenusFilterBo.field = "fucntionCode";
        this.MenusFilterBo.matchCase = false;
        this.MenusFilterBo.operator = "contains";
        this.MenusFilterBo.value = "";
        this.MenusFilterBo.type = "string";
      }
    }
    this.getFunctionFilter();
    if (val == "paging" && F.action.name == "actionBegin") {
      // if (this.arraycol.length != 0) {
      //   if (this.arraycol[0].Question.Pagesize != Q.take) {
      //     this.arraycol[0].Question.Pagesize = Q.take
      //     // this.SaveColumnwidth();
      //   }
      // }
    }
  }
  //.........................................onActionFunction.....................................................
  public onActionFunction(F) {
    this.MenusFilterBo.currentpageno = this.gridFunction.pagerModule.pagerObj.currentPage;
    this.MenusFilterBo.pageitem = this.gridFunction.pagerModule.pagerObj.pageSize;
    if (F.name == "actionBegin" && F.requestType == "filterbeforeopen") {
      this.MenusFilterBo.type = F.columnType
    }
  }
  //...........................................getDetails..........................................
  getDetails(saveBos: saveFunctionBo) {
    this.saveFunctionInfo = JSON.parse(JSON.stringify(saveBos));
  }
   //.......................................getFunctionFilter............................................
  getFunctionFilter() {
   
    this.MenusFilterBo.sideMenuId=this.InputProperty.Id;
    this.DateService.executeFunction(this.MenusFilterBo);
    let count = 0;
    this.GridList.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      count = count + 1;
      if (data != null && data.result.length > 15) {
        this.gridFunction.height = '500';
      }
      else {
        this.gridFunction.height = 'auto';
      }
    })
  }

  //.........................................SaveOrUpdateFunction.............................................
  SaveOrUpdateFunction() {
   this.isSaveorUpdateBoolean=true;
    let savepayload: saveFunctionBo = JSON.parse(JSON.stringify(this.saveFunctionInfo));
    savepayload.id = this.saveFunctionInfo.id;
    savepayload.sideMenuItemsId=this.InputProperty.Id;
    this.MService.saveupdateFunction(savepayload).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.isSaveorUpdateBoolean=false;
      if (this.saveFunctionInfo.id == '00000000-0000-0000-0000-000000000000') {
        this.toasterservice.success('Function saved successfully!');
        setTimeout(() => {
          this.toasterservice.clear();
        }, 8000);
      }
      else if (this.saveFunctionInfo.id != '00000000-0000-0000-0000-000000000000') {
        this.toasterservice.success('Function updated successfully!');
        setTimeout(() => {
          this.toasterservice.clear();
        }, 8000);
      }
      this.closeFunction();
      this.getFunctionFilter();
    }, (err: any) => {
      this.isSaveorUpdateBoolean=false;
      if (err) {
        this.toasterservice.error(err, 'Error'), 8000;
      }
    })
  }
  //......................................closeFunction........................................................
  closeFunction()
  {
    this.saveFunctionInfo = new saveFunctionBo();
    document.getElementById('openFunctionModal').click();
  }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}

